import React from "react";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

function BiltSorryComponent(props) {

  return (
    <React.Fragment>
                  <p className="eca-switchoff-summary1">
                    {parse(DOMPurify.sanitize(props.utilityLabel1.utilityLabel.switchoffSummary1))}
                  </p>
                </React.Fragment>
  );
}

export default BiltSorryComponent;
